import {AlertService} from "./AlertService";
import {ValidationService} from "./ValidationService";
import {WarningService} from "../../../services/WarningService";

export class DocumentService {
    constructor(form) {
        this.form = form;
        this.checkDocumentLimitUrl = $("#check-document-limit").val();
        this.checkInClosedGroupUrl = $("#check-in-closed-group").val();
        this.checkAnyDocumentIsLockedUrl = $("input#check-any-document-is-locked").val();
        this.prevalidateCashRegisterSaveUrl = $("#prevalidate-cash-register-save").val();
        this.lastOperationGroupDatesUrl = $("input#getLastOperationGroupDates").val();
        this.getAdvancePaymentsDocumentsUrl = $("input#get-advance-payments-documents").val();
        this.getConnectedWithDocumentUrl = $("input#get-connected-with-document").val();
        this.getContractorUnallocatedPaymentsUrl = '/summaries/payments-and-unallocated-documents/contractor-payments';
        this.getDocumentTemplatesUrl = $("input#get-document-templates").val();
        this.getAdvancePaymentsForContractUrl = $("input#get-advance-payments-for-contract").val();
        this.getRelatedDocumentsUrl = '/records/documents/get-related-documents';
        this.getCheckVatRatesUrl = '/records/documents/check-vat-rates';
        this.getRemainingForInvoicingItemsUrl = '/records/contracts/remaining-for-invoicing-items';
        this.getAdvanceAmountCalculationUrl = '/records/documents/calculate-advance-amounts'
        this.getAdvancePaymentDocumentsUrl = '/records/contracts/advance-payment-documents';

        this.alertService = new AlertService();
        this.validationService = new ValidationService(form);
        this.warningService = new WarningService();
    }

    getLastOperationGroupDates(sourceId, group_id) {
        return $.post(this.lastOperationGroupDatesUrl, {
            payment_source_id: sourceId, group_id: group_id,
        });
    }

    checkDocumentLimit() {
        return $.get(this.checkDocumentLimitUrl, {
            document_number: $('#document_number_id').val(),
            date_issued: $('input[name="date_issued"]').val(),
            series_id: $('select[name="series_id"]').val() == undefined ? 0 : $('select[name="series_id"]').val(),
            is_archival: $('input[name="is_archival"]').is(':checked'),
            document_type: $('input[name="document_type"]').val(),
            document_id: $('input[name="id_document"]').val()
        });
    }

    getConnectedWithDocument(documentId) {
        return $.get(`${this.getConnectedWithDocumentUrl}/${documentId}`);
    }

    getAdvancePaymentsDocuments(data) {
        return $.get(this.getAdvancePaymentsDocumentsUrl, data);
    }

    getContractorUnallocatedPayments(contractorId) {
        return $.get(`${this.getContractorUnallocatedPaymentsUrl}/${contractorId}`);
    }

    getAdvancePaymentsForContract(contractId, currentDocumentId, gross_calculation) {
        return $.get(`${this.getAdvancePaymentsForContractUrl}/${contractId}`, {currentDocumentId, gross_calculation});
    }

    getRelatedDocuments(documentIds) {
        return $.post(this.getRelatedDocumentsUrl, {documentIds});
    }

    checkVatRates(documentIds, contract) {
        return $.post(this.getCheckVatRatesUrl, {documentIds, contract});
    }

    getRemainingForInvoicingItems(contractId, ignoreDocumentsIds = []) {
        return $.get(`${this.getRemainingForInvoicingItemsUrl}/${contractId}`, {ignoreDocumentsIds});
    }

    getAdvanceAmountCalculation() {
        return $.post(`${this.getAdvanceAmountCalculationUrl}`, {
            mode: $('input[name="mode"]').val(),
            copy: $('input[name="isMakingCopy"]').val(),
            contract_id: $('input[name="contract_id"]').val(),
            amount:$('.advance_amount').val(),
            document_id:$('input[name="id_document"]').val()
        });
    }

    getAdvancePaymentDocuments(contractId, documentId) {
        return $.get(`${this.getAdvancePaymentDocumentsUrl}/${contractId}`, {documentId});
    }

    getDocumentTemplates(data) {
        return $.post(`${this.getDocumentTemplatesUrl}`, data);
    }

    checkDocumentInClosedGroup(documentId) {
        return $.get(`${this.checkInClosedGroupUrl}/${documentId}`);
    }

    checkAnyDocumentIsLocked(documentsIds) {
        return $.post(this.checkAnyDocumentIsLockedUrl, {documents: documentsIds, parent:$('input[name="id_document"]').val()});
    }

    prevalidateCashRegisterSave(data) {
        return $.post(this.prevalidateCashRegisterSaveUrl, data);
    }

    async generateDuplicate(documentId) {
        return $.get(`/records/documents/${documentId}/copy-pdf`);
    }

    async generateDocumentPreview(templateId, documentData) {
        return $.post(`/records/documents/${templateId}/flash-form-for-pdf`, documentData);
    }

    getStatusLabelClass(status) {
        switch (status) {
            case 'confirmed':
                return 'label-plain';
            case 'rejected':
                return 'label-black';
            case 'not_confirmed':
                return 'label-danger';
            default:
                return '';
        }
    }

    async handleDocumentLimit() {
        const {canSubmit, message} = await this.checkDocumentLimit();

        if (!canSubmit) {
            await this.alertService.showDocumentLimitSwal(message);
        }

        return !canSubmit;
    }

    async handleSubmitNotAllowed(checkType) {
        try {
            const isValid = await this.validationService.validate(checkType);

            if (!isValid || this.warningService.hasVisiblePreventSubmitWarning) {
                await this.alertService.showSaveNotAllowedSwal();
                return true;
            }
        } catch (e) {
            console.error(e);
            await this.alertService.showValidationUnexpectedErrorSwal();
            return true;
        }

        return false;
    }

    async handleVatRatesForInvoicePl() {
        const canSubmit = this.checkVatRatesAvailableForIsoCodes(['XX', 'PL']);

        if (!canSubmit) await this.alertService.showDocumentContainForeignVatRatesSwal();

        return !canSubmit;
    }

    checkVatRatesAvailableForIsoCodes(codes = []) {
        let isAvailable = false;
        this.form.goodsForm.inputs.items.vatRate.each((key, input) => {
            const optionIsoCode = $(input).find('option:selected').data("iso_code");
            isAvailable = codes.includes(optionIsoCode);
            if (!isAvailable) return false;
        });

        return isAvailable;
    }

    async handleSubmitAsRejected() {
        const {isConfirmed} = await this.alertService.showDocumentSaveAsRejectedSwal(this.form.isForeign);

        return !isConfirmed;
    }

    async getRelatedDocumentsIds(documentIds) {
        let {relatedIds} = await this.getRelatedDocuments(documentIds);
        const difference = relatedIds.filter(x => !documentIds.includes(x));

        if (difference.length > 0) {
            const {isConfirmed} = await this.alertService.showRelatedDocumentsSwal();

            if (!isConfirmed) relatedIds = [];
        }

        return relatedIds;
    }

    async checkVatRatesAvailable(documentIds, contractId) {
        let {status} = await this.checkVatRates(documentIds, contractId);
        if(status == 'success'){
            return documentIds;
        }
        else{
            await this.alertService.showDocumentVatRatesInvalid();
            return [];
        }

    }


    async handleDocumentInClosedGroup(documentId) {
        const {inClosedGroup} = await this.checkDocumentInClosedGroup(documentId);

        if (inClosedGroup) await this.alertService.showDocumentInClosedGroupSwal();

        return inClosedGroup;
    }

    canSaveCashRegisterDocument(saveAsRejected = false) {
        const dataToCheck = {
            id_document: this.form.documentId,
            operation_id: this.form.context.operationId,
            payment_method_type: this.form.paymentsForm.paymentMethodType,
            operation_method: this.form.context.operationMethod,
            source_type: this.form.context.sourceType,
            contractor_id: this.form.contractorForm.contractorOriginalId,
            gross_sum: this.form.goodsForm.getSummaryInputValue('grossSum'),
            save_as_rejected: saveAsRejected,
            payment_source_id:$("input[name='payment_source_id']").val() != '' ? $("input[name='payment_source_id']").val() : $("select[name='payment_type']").val(),
            document_date: $("input[name=document_type]").val() == 'cash_register_receipt' ? $("input[name=date_issued]").val() : $("input[name=sale_date]").val(),
        };

        return this.prevalidateCashRegisterSave(dataToCheck);
    }

    handleIsSameContractInAdvancePayments(documents) {
        const firstContractId = documents[0]?.contract_id;
        const isSameContractId = documents.every(document => document.contract_id === firstContractId);

        if (!isSameContractId) this.alertService.showAdvancePaymentsHasDifferentContractSeal();

        return isSameContractId;
    }

    handleNotCompletedKsefSending(documents) {
        let valid = true;
        const notCompleted = documents.every(document => document.not_completed_ksef_sending == 0);

        if (!notCompleted) this.alertService.showNotCompletedKsefAlert();

        return notCompleted;
    }

    handleCorrectedDocuments(documents) {
        if($('input[name="mode"]').val() != 'edit'){
            return true;
        }
        let editedDocumentId = $('input[name="id_document"]').val();
        if(editedDocumentId == 0){
            return true;
        }
        const idLessThanEditedDocument = documents.every(document => document.corrected_document_id <= editedDocumentId);

        if (!idLessThanEditedDocument) this.alertService.showSelectedIdGreatherThanEditedDocument();

        return idLessThanEditedDocument;
    }

    async handleLockedDocuments(documents) {
        const {locked, message} = await this.checkAnyDocumentIsLocked(documents);
        if (locked) {
            this.alertService.showSwal('', message);
        }
        else{
            lock_documents(documents,[], [])
            localStorage.setItem('documents_to_unlock', documents);
        }

        return locked;
    }
}
